<template>
  <div class="presupuesto-interno-renglones alternativas">
    <b-card>
      <template slot="header">
        Alternativas
        <b-btn class="btn-collapse-card" 
            variant="primary" 
            size="sm"
            @click.prevent="closeAlternativas">
          <i class="fa fa-remove"></i>
        </b-btn>
      </template>
      <b-table
          :key="key"
          small 
          responsive="sm"
          :busy="tableBusy"
          :class="{ 
            'registro-ordenes': true,
            'alternativas': true, 
            'cotizacion-interna': tieneRecargoServicioPropio
          }"
          :items="ordenesAlternativasDatos" 
          :fields="renglonesFields">
        <div slot="table-busy" class="text-center">
          <b-spinner class="table-spinner" label="Spinning" />
        </div>
        <template v-slot:cell(tieneImagenes)="data">
          <template v-if="data.item.tieneImagenes">
            <i class="fa fa-image"></i>
          </template>
        </template>
        <template v-slot:cell(rubroTrabajo)="data">
          {{ data.item.rubroTrabajo }}
        </template>
        <template v-slot:cell(costoInterno)="data">
          {{ data.item.costoInterno | moneda(data.item.moneda) }}
        </template>
        <template v-slot:cell(pjeRentabilidad)="data">
          <template v-if="data.item.costoInterno != 0">
            {{ data.item.pjeRentabilidad | porcentaje }}
          </template>
          <template v-if="data.item.costoInterno == 0">
            {{ '--.--%' }}
          </template>
        </template>
        <template v-slot:cell(pjeImpuestos)="data">
          {{ data.item.pjeImpuestos | porcentaje }}
        </template>
        <template v-slot:cell(cotizacionInterna)="data">
          {{ data.item.cotizacionInterna | moneda(presupuestoDatos.moneda) }}
        </template>
        <template v-slot:cell(cotizacion)="data">
          {{ data.item.cotizacion | moneda(presupuestoDatos.moneda) }}
        </template>
        <template v-slot:cell(seleccionada)="data">
          <span v-if="data.item.seleccionada" class="col-alternativas">*</span>
          <!-- {{ data.item.seleccionada ? "*" : "" }} -->
        </template>

        <template v-slot:cell(detailShowing)="row">
          <b-btn class="detailShowing" 
              size="sm" 
              v-if="row.item.descripcion != ''"
              @click.stop="row.item._showDetails = !row.item._showDetails">
            {{ row.item._showDetails ? '-' : '+' }}
          </b-btn>            
        </template>

        <template v-slot:row-details="row">
          <b-row v-if="row.item.descripcion != ''">
            <b-col xl="12">
              <p class="orden-descripcion"> {{ row.item.descripcion }} </p>
            </b-col>
          </b-row>
        </template>
      </b-table>

      <small><span class="col-alternativas">*</span> Alternativa seleccionada </small>  
    </b-card>
    
    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
// import OrdenTrabajoImagenes from '../ordenestrabajos/Imagenes';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { mapState } from 'vuex';

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'presupuestoInternoDatos/getField',
  mutationType: 'presupuestoInternoDatos/updateField',
});

export default {
  name: 'PresupuestosInternosAlternativasData',
  components: {
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal, 
    confirmModal
  ],
  // props: {
  //   accesoImagenes: {
  //     type: Boolean,
  //     default: false
  //   }
  // },
  data () {
    return {
      labelCols: 2,
      tableBusy: false,
      key: 1000
    }
  },
  computed: {
    ...mapFields([
      'presupuestoDatos',

      'ordenTrabajoAlternativas',
      'ordenesAlternativasDatos'
    ]),
    tieneRecargoServicioPropio() {
      return this.presupuestoDatos.pjeRecargoServicioPropio != 0;
    },
    renglonesFields() {
      let fields = [
        { 
            key: 'tieneImagenes',
            label: '',
            class: 'text-center'
        },
        {
          key: 'detailShowing',
          label: '',
          class: 'text-center'
        },
        // {
        //   key: 'rubroTrabajo',
        //   label: 'Rubro',
        //   sortable: true
        // },
        {
          key: 'titulo',
          sortable: true
        },
        { 
          key: 'cantidad', 
          class: "text-right" },
        { 
          key: 'costoInterno', 
          label: 'Costo Interno',
          class: "text-right" 
        },
        { 
          key: 'pjeRentabilidad', 
          class: "text-right", 
          label: '% Rent.' 
        },
      ]

      if (this.presupuestoDatos.pjeRecargoServicioPropio != 0) {
        fields.push({ 
            key: 'cotizacionInterna', 
            class: "text-right", 
            label: 'Cotización Interna'
          });
      }
      fields.push({ 
        key: 'cotizacion', 
        class: "text-right", 
        label: 'Cotización'
      });
      fields.push({
        key: 'seleccionada',
        label: '',
        class: 'text-center'
      });
      fields.push({
        key: 'opciones',
        label: '',
        class: 'text-center'
      });
      
      return fields;
    }
  },  
  created() {
  },
  destroyed() {
  },
  methods: {
    refresh() {
      this.key++;
    },
    closeAlternativas() {
      this.$emit('closeAlternativas');
    }
  },
  watch: {
  }    
}
</script>

<style>
/* Imagenes */
.presupuesto-interno-renglones.alternativas .registro-ordenes.alternativas table td[aria-colindex="1"] {
  width: 20px;
}
/* Detail showing */
.presupuesto-interno-renglones.alternativas .registro-ordenes.alternativas table td[aria-colindex="2"] {
  width: 20px;
}
/* Titulo */
.presupuesto-interno-renglones.alternativas .registro-ordenes.alternativas table td[aria-colindex="3"] {
  width: calc(62% - 80px);
}
/* Cantidad */
.presupuesto-interno-renglones.alternativas .registro-ordenes.alternativas table td[aria-colindex="4"] {
  width: 8%;
}
/* Costo Interno */
.presupuesto-interno-renglones.alternativas .registro-ordenes.alternativas table td[aria-colindex="5"] {
  width: 10%;
}
/* Pje Rentabilidad */
.presupuesto-interno-renglones.alternativas .registro-ordenes.alternativas table td[aria-colindex="6"] {
  width: 10%;
}
/* Cotizacion */
.presupuesto-interno-renglones.alternativas .registro-ordenes.alternativas table td[aria-colindex="7"] {
  width: 10%;
}
/* Seleccionada */
.presupuesto-interno-renglones.alternativas .registro-ordenes.alternativas table td[aria-colindex="8"] {
  width: 15px;
}
/* Opciones */
.presupuesto-interno-renglones.alternativas .registro-ordenes.alternativas table td[aria-colindex="9"] {
  width: 25px;
}

/* Presupuesto con recargo en servicios propios (con cotizacion interna) */

/* Titulo */
.presupuesto-interno-renglones.alternativas .registro-ordenes.alternativas.cotizacion-interna table td[aria-colindex="3"] {
  width: calc(34% - 65px);
}
/* Cotizacion Interna */
.presupuesto-interno-renglones.alternativas .registro-ordenes.alternativas.cotizacion-interna table td[aria-colindex="7"] {
  width: 10%;
}
/* Cotizacion */
.presupuesto-interno-renglones.alternativas .registro-ordenes.alternativas.cotizacion-interna table td[aria-colindex="8"] {
  width: 10%;
  color: #23282c;
}
/* Seleccionada */
.presupuesto-interno-renglones.alternativas .registro-ordenes.alternativas.cotizacion-interna table td[aria-colindex="9"] {
  width: 15px;
  color: blue;
}
/* Opciones */
.presupuesto-interno-renglones.alternativas .registro-ordenes.alternativas.cotizacion-interna table td[aria-colindex="10"] {
  width: 25px;
}
</style>